import PropTypes from 'prop-types';
import styles from './FJMobileQuantity.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import classNames from 'classnames';
const FJMobileQuantity = props => {
    const { generateQuantity, changeGenerateQuantity } = props;
    return (
        <div className={styles.amount_box}>
            <div className={styles.amount_title}>{FJLocalStore._('quantity')}</div>
            <div className={styles.amount_list}>
                {new Array(1, 2, 3, 4).map(item => (
                    <FJHoverBoardGradation
                        key={item}
                        active={generateQuantity === item}
                        contentClassName={classNames(
                            styles.amount_item_text,
                            generateQuantity === item ? styles.active : '',
                        )}
                        className={styles.amount_item}
                        onClick={() => changeGenerateQuantity && changeGenerateQuantity(item)}
                    >
                        {item}
                    </FJHoverBoardGradation>
                ))}
            </div>
        </div>
    );
};
FJMobileQuantity.propTypes = {
    generateQuantity: PropTypes.number,
    changeGenerateQuantity: PropTypes.func,
};

export default FJMobileQuantity;
